import { render, staticRenderFns } from "./PackingBoat.vue?vue&type=template&id=198a2b0c"
import script from "./PackingBoat.vue?vue&type=script&lang=js"
export * from "./PackingBoat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports